export const ru = {
    all: 'Все',
    'find-platforms': 'Найти площадки',
    format: 'Формат',
    operator: 'Оператор',
    selected: 'Выбранные'
};
